import { Avatar, Flex } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useChatSettings } from '@guuru/chat-web';
import { BOTS } from '@guuru/expert-common';
import Headline from './Headline';
import { Spacer } from './styles';

const Heading = function ({ chat = {} }) {
  const {
    data: {
      chatSettings: {
        chatWidgetShowProfiles,
        chatWidgetProfilesPictures,
        chatWidgetProfilesCount,
      },
    } = {},
  } = useChatSettings();

  const expertName = chat?.expert?.name;
  const isBot = chat?.expert?.id === BOTS.bot.externalId;

  const heroes = useMemo(() => {
    const sorted = [...chatWidgetProfilesPictures].sort(
      () => Math.random() - 0.5,
    );
    const missingProfilesCount = chatWidgetProfilesCount - sorted.length;
    return chatWidgetProfilesCount > chatWidgetProfilesPictures.length
      ? [
          ...sorted,
          ...Array.from({ length: missingProfilesCount }, (_, i) => i),
        ]
      : sorted;
  }, [chatWidgetProfilesCount, chatWidgetProfilesPictures]);

  return (
    <Flex>
      <Spacer orientation="vertical">
        <Headline chat={chat} />
        {(!expertName || isBot) && chatWidgetShowProfiles && (
          <Avatar.Group
            aria-hidden="true"
            max={{
              count: Math.min(chatWidgetProfilesPictures.length, 6),
              popover: { trigger: 'none' },
              style:
                chatWidgetProfilesPictures.length < 6
                  ? { display: 'none' }
                  : { boxShadow: 'none', opacity: 0.9 },
            }}
          >
            {heroes.map((url) => (
              <Avatar src={url} size={38} key={url} alt="" />
            ))}
          </Avatar.Group>
        )}
      </Spacer>
    </Flex>
  );
};

Heading.propTypes = {
  chat: PropTypes.shape({
    expert: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    isAssignedToAgent: PropTypes.bool,
  }),
};

export default Heading;
